import get from 'lodash-es/get'

import { getConfigBySite } from '../../config/sites'
import { IItem } from '../../typings/searchResults'
import { config } from '../config'

const itemSmallPreviewUrl = (item: IItem): string => {
  const previewPaths = getConfigBySite(
    'defaults',
    'ui.item_small_preview_paths'
  ) as string[]
  const previewPath: string = previewPaths
    .map(path => get(item.previews, path))
    // return first non falsy value
    .reduce((prevPath, currPath) => {
      if (prevPath) {
        return prevPath
      }
      return currPath
    })
  if (previewPath) {
    return previewPath
  }
  return `${config.assets.PUBLIC_PATH}${getConfigBySite(
    'defaults',
    'ui.default_user_image_path'
  )}`
}

export default itemSmallPreviewUrl
